<template>
    <div class="form">
        <!-- Opening hours options -->
        <div class="form__section">
            <div class="form__title">Passierbarkeit</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrChoiceGroup 
                        :values="data.roadConnection" 
                        :options="roadConnectionOptions"
                        @change="fieldChangeHandler($event, 'roadConnection')"
                    />
                </div>
            </div>
        </div>
        <!-- Other filter options -->
        <div class="form__section">
            <div class="form__title">Weitere Filteroptionen</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrChoiceGroup 
                        :values="data.other" 
                        :options="otherOptions"
                        @change="fieldChangeHandler($event, 'other')"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import settingsTabBlueprint from '@/mixins/settings-tab-blueprint';
import messageBoxBlueprint from '@/mixins/message-box-blueprint.js';
import SmrChoiceGroup from '@/components/form/SmrChoiceGroup.vue'

export default {
    components: {
        SmrChoiceGroup,
    },
    mixins: [
        settingsTabBlueprint,
        messageBoxBlueprint
    ],
    data() {
        return {
            data: {},
            roadConnectionOptions: [
                {value: 'suitableForCampers',label: 'Für Wohnwagen geeignet'},
                {value: 'openAllYear', label: 'Ganzjährig geöffnet'},
            ],
        }
    },
    computed: {
        ...mapGetters(['user']),
        otherOptions() {
            return [
                {value: 'favouritesOnly', label: 'Nur Favoriten', disabled: this.user ? false : true},
            ]
        }
    }
}
</script>
